
<template lang="pug">
.weather
  template(v-if="data")
    WeatherIcon.weather__icon(:text="data.before")
    .inline-block.q-mx-xs /
    WeatherIcon.weather__icon(:text="data.after" night)
    q-tooltip.app__tooltip(
      anchor="bottom right"
      self="top right"
    )
      div 参考日の徳島市の天気
      div 昼：{{data.before}}
      div 夜：{{data.after}}
  template(v-else)
    i.wi.wi-na
    q-tooltip.app__tooltip(
      anchor="bottom right"
      self="top right"
    ) {{data || '気象情報がありません'}}
</template>

<script>
import 'weathericons/sass/weather-icons.scss'

import WeatherIcon from 'components/WeatherIcon'

export default {
  components: {WeatherIcon},

  props: {
    data: Object,
  },
}
</script>

<style lang="sass">
.weather
  font-size: 16px
  min-width: 64px
  text-align: center

.weather__icon
  width: 20px

  </style>
